export enum SoftwareSummaryKeys {
  SOFTWARE_ID = "softwareId",
  NAME = "name",
  NUMBER_OF_LICENCED_USERS = "numberOfLicencedUsers",
}

export interface SoftwareSummary {
  [SoftwareSummaryKeys.SOFTWARE_ID]: string;
  [SoftwareSummaryKeys.NAME]: string;
  [SoftwareSummaryKeys.NUMBER_OF_LICENCED_USERS]: number;
}
